import React from "react";
import './App.css';
import Birthdays from "./Components/Birthdays";

class App extends React.Component{

  render(){

    return(
      <div>
        <Birthdays />
      </div>
    )
  }
}

export default App;
